module.exports = __webpack_public_path__ + "img/1519664292.0f13c5e1.jpg";